<template>
    <div :class="{'mobile-menu-group-item': true, 'selected': selected}">
        <img v-if="icon" :src="icon" width="16" height="16" /> 
        <span v-else class="no-image"></span>
        <slot>
            <a :href="url"> {{name}}</a>
        </slot>
    </div>
</template>

<script>

export default {
    props: ["name", "icon", "url",],
    components: {
    },
    mounted() {
        this.refresh();
        window.addEventListener('mobile-menu-recalc-item', this.refresh);
    },
    unmounted() {
        window.removeEventListener('mobile-menu-recalc-item', this.refresh);
    },
    data() {
        return {
            selected: false,
        };
    },
    methods: {
        isCurrent() {            
            const url = document.location.pathname;
            if (url === this.url) {
                return true;
            }
            const index = url.indexOf(this.url);
            if (index > 0) {
                const diff = url.replace(this.url, "");
                console.warn(`url=${url}, url2=${this.url}, diff=${diff}`);
                if (diff[0] == '/') {
                    if (diff.length == 3) {
                        console.log("YES3");
                        return true;
                    }
                    if (diff.length == 5 && diff[3] == "-") {
                        console.log("YES5");
                        return true;
                    }
                }
            }
            return false;
        },
        refresh() {
            this.selected = this.isCurrent();
        },
    }
}
</script>

<style lang="scss" scoped>
    .mobile-menu-group-item {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 18px;
        padding-right: 16px;
        .no-image {
            display: inline-block;
            width: 16px;
            margin-right: 6px;
        }
        img {
            width: 16px;
            position: relative;
            margin-right: 6px;
        }
                
        a { 
            color: #808080;           
            text-decoration: none;
            width: 100%;
            cursor: pointer;
        }
    }
</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
